import { ISubscriptionPlan } from '@/shared/interfaces';

type ActiveProgramsViewProps = {
    subscriptions: ISubscriptionPlan[];
};

export const ActiveProgramsView = ({
    subscriptions,
}: ActiveProgramsViewProps) => {
    return (
        <>
            {subscriptions.map(({ Name }) => (
                <span className="mr-2 font-bold" key={Name}>
                    {Name}
                </span>
            ))}
        </>
    );
};
